import React from 'react';

import './index.css';

const ResetPassword = (props) => {
  const onClick = (e) => {
    e.stopPropagation();
    props.resetPassword(props.row)
  }

  return (
    props.role === 'admin' || props.row.role === 'other' || props.row.role === 'standard'
    ? <span onClick={onClick} className="action-reset-password">Reset</span>
    : <span className="action-reset-password"></span>
  );
}

export default ResetPassword;